<style lang="stylus">
    .box
        width 50px
        height 50px
        background #6cf
</style>

<template>
    <div>
        <template v-if="adType == 'topbar'">
            <ADTopbar :activityData="activityData" :activityTime="activityTime" :isCheckLog="isCheckLog" @updateActivity="updateActivity" />
        </template>
        <template v-else-if="adType == 'float'">
            <ADFloat
                :activityData="activityData"
                :activityTime="activityTime"
                :isCheckLog="isCheckLog"
                :activityKey="activityKey"
                @updateActivity="updateActivity"
            />
        </template>
        <template v-else-if="adType == 'alert'">
            <ADAlert
                :activityData="activityData"
                :activityTime="activityTime"
                :isCheckLog="isCheckLog"
                :activityKey="activityKey"
                @updateActivity="updateActivity"
            />
        </template>
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import ADTopbar from "./AD-topbar.vue";
    import ADFloat from "./AD-float.vue";
    import ADAlert from "./AD-alert.vue";

    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({
        components: {
            ADTopbar,
            ADFloat,
            ADAlert,
        },
    })
    export default class AD extends Vue {
        @Prop()
        adType;

        activeID: number = 0; // 活动id，后期改为服务器获取
        activityKey: string = "";
        activityData: any = {};
        activityTime: boolean = false;
        isCheckLog: boolean = false;
        retryCount: number = 0;
        delay: number = 0;

        get userInfo() {
            return this.$store.state.userInfo;
        }
        get vipState() {
            if (this.isPC) {
                return this.$store.state.pcVip;
            } else {
                return this.$store.state.publicStore.vip;
            }
        }
        // 检验是否启用，是否处于活动时间，是否会员屏蔽，是否手动关闭
        get showTopbar() {
            return this.$store.state.showTopbar && this.isCheckLog;
        }
        get showFloat() {
            return this.$store.state.showFloat && !this.showAlert && this.isCheckLog;
        }
        get showAlert() {
            return this.$store.state.showAlert && this.isCheckLog;
        }
        getActivity() {
            // 获取广告信息
            let lang = !this.internal && "zh" == this.lang ? "en" : this.lang;
            let linkKey = `out${this.isPC ? "PC" : ""}Url`;
            return new Promise((rs, rj) => {
                this.$edApi
                    .getActivity({
                        position: this.adType == "topbar" ? 2 : 1,
                        lang: this.lang,
                        platform: this.isPC ? "other" : "web",
                        token: this.userInfo.token || "",
                        pid: this.pid,
                    })
                    .then((arr) => {
                        this.activityData = {};
                        for (let i = 0; i < arr.length; i++) {
                            let e = arr[i];
                            if (e.pids && e.pids.length && e.pids.includes(String(this.pid))) {
                                this.activityKey = `global_${e.id}`;
                            } else {
                                this.activityKey = `${this.lang}_${e.id}`;
                            }
                            if (this.adType != "alert" && this.getLocal(`${this.adType}_ad`)) {
                                continue;
                            }
                            this.activityData.type = this.adType;
                            this.activityData.actived = e.open;
                            this.activityData.imgUrl = window["GLOBAL"].PUBLIC_OSS_HOST + e.picture;
                            this.activityData.linkUrl = e.link;
                            this.activityData.vip = e.members;

                            this.activityTime =
                                new Date().getTime() >= new Date(e.start_at).getTime() && new Date().getTime() <= new Date(e.end_at).getTime();
                            break;
                        }
                        rs(null);
                    })
                    .catch((err) => {
                        rj(err);
                    });
            });
        }
        setLocal(type) {
            type = `${type}_${this.userInfo.user_id}`;
            let storageItem = JSON.parse(localStorage.getItem(type)) || [];
            storageItem.push(this.activityKey);
            localStorage.setItem(type, JSON.stringify(storageItem));
        }
        getLocal(type) {
            type = `${type}_${this.userInfo.user_id}`;
            let storageItem = JSON.parse(localStorage.getItem(type)) || [];
            let data = storageItem.reduce((p, c) => {
                if (c == this.activityKey) {
                    (p.num && p.num++) || (p.num = 1);
                }
                return p;
            }, {});
            return data.num >= 3;
        }
        setSession() {
            sessionStorage.setItem(`alert_${this.userInfo.user_id}`, "1");
        }
        getSession() {
            let item = sessionStorage.getItem(`alert_${this.userInfo.user_id}`);
            this.setSession();
            return item;
        }
        checkActivity() {
            if (Object.keys(this.activityData).length == 0) return;
            let type = "",
                data = false;
            let role = "";
            if (this.vip) {
                role = this.fuser ? "viplife" : "vipnonlife";
            } else {
                role = "nonvip";
            }
            let vipShow = this.activityData.vip.includes(role);
            switch (this.adType) {
                case "topbar":
                    type = "showTopbar";
                    data = this.activityData && this.activityData.actived && this.activityTime && vipShow;
                    break;
                case "float":
                    type = "showFloat";
                    data = this.activityData && this.activityData.actived && this.activityTime && vipShow && !this.getLocal("float_ad");
                    break;
                case "alert":
                    type = "showAlert";
                    data =
                        this.activityData && this.activityData.actived && this.activityTime && vipShow && !this.internal
                            ? !this.getLocal("alert_ad")
                            : !this.getSession();
                    break;
            }
            this.$store.commit("setState", {
                type,
                data,
            });
        }
        updateActivity() {
            if (this.isHW) {
                return;
            }
            this.isCheckLog = true;
            this.getActivity().then(() => {
                this.checkActivity();
            });
        }
        isHW = false;
        created() {
            const query = location.search && new URLSearchParams(location.search.slice(1));
            this.isHW = query && !!query.get("hwpad");
        }
    }
</script>
